import React, { useEffect, useState } from 'react'
import "./Contact.css"
import logo from "../../assets/Logoblack.png"
import ContactForm from './CotactForm';
import AnimiatedPage from '../../AnimiatedPage';
import styles from "./ContactFrom.module.css"
function Contact() {
    const [len, setLen] = useState(190)

    var windowWidth = window.innerWidth
    useEffect(() => {
        if (windowWidth <= 700) {
            // setLen(100)
        }
    }, [])
    useEffect(()=>{
        document.title = 'SHARVIL Business Group -Cotact'
        },[])
    //console.log(len)
    return (
        <AnimiatedPage>


            <div className='contact'>
                <div className='contactForm'>
                    <div className='contactFomrBody'>
                        <ContactForm />
                    </div>

                </div>

                <div className={styles.bottomRightMidCircle}></div>
                <div className={styles.bottomCircle}></div>
                <div className={styles.bottomRightCircle}></div>
                <div className={styles.bottomLeftCircle}></div>
                <div className={styles.bottomLeftSideCircle}></div>
                <div className={styles.topRightSideCircle}></div>
                <div className={styles.mobileTop}></div>
                <div className={styles.mobileRightBottom}></div>
            </div>
        </AnimiatedPage>
    )
}

export default Contact